import React, { useState } from 'react';
import { GeneratedCredential } from '../../types';

interface ResetPasswordConfirmationModalProps {
  credential: GeneratedCredential;
  onClose: () => void;
}

const ResetPasswordConfirmationModal: React.FC<ResetPasswordConfirmationModalProps> = ({ credential, onClose }) => {
  const [copyStatus, setCopyStatus] = useState<'idle' | 'copied'>('idle');

  const handleCopyToClipboard = () => {
    const textToCopy = `Username: ${credential.username}\nTemporary Password: ${credential.password}`;
    navigator.clipboard.writeText(textToCopy).then(() => {
        setCopyStatus('copied');
        setTimeout(() => setCopyStatus('idle'), 2000);
    });
  };
    
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" onClick={onClose}>
      <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-md" onClick={(e) => e.stopPropagation()}>
        <div className="flex justify-between items-center mb-4 border-b pb-4">
          <h2 className="text-2xl font-bold text-gray-800">Password Reset</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-800 text-3xl">&times;</button>
        </div>
        <div className="p-4 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 mb-4 rounded-r-lg">
            <h4 className="font-bold">Important!</h4>
            <p>Please provide this temporary password to the student. It will not be shown again.</p>
        </div>
        <div className="space-y-4">
            <div>
                <label className="block text-sm font-medium text-gray-500">Student</label>
                <p className="text-lg font-semibold text-gray-800">{credential.fullName}</p>
            </div>
             <div>
                <label className="block text-sm font-medium text-gray-500">Username</label>
                <p className="text-lg font-mono bg-gray-100 p-2 rounded">{credential.username}</p>
            </div>
             <div>
                <label className="block text-sm font-medium text-gray-500">New Temporary Password</label>
                <p className="text-lg font-mono bg-gray-100 p-2 rounded">{credential.password}</p>
            </div>
        </div>
        <div className="flex justify-end space-x-4 mt-6">
            <button onClick={handleCopyToClipboard} className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors">
                {copyStatus === 'idle' ? 'Copy Credentials' : 'Copied!'}
            </button>
            <button onClick={onClose} className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600">Close</button>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordConfirmationModal;